// frontend/src/auth/Register.js
// VERSIÓN MODIFICADA - No guarda token en localStorage
// Solo pasa datos por state a PricingPlans

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import '../UserLogin.css';

export default function RegisterAdmin() {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    condominiumName: '',
    phone: '',
    address: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);

    // Validaciones
    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (!formData.condominiumName || formData.condominiumName.trim() === '') {
      setError('El nombre del condominio es obligatorio');
      return;
    }

    setLoading(true);

    try {
      console.log('📵 Iniciando registro de admin + condominio...');
      
      const resp = await fetch(API_ENDPOINTS.registerAdmin, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          username: formData.username,
          email: formData.email,
          password: formData.password,
          condominiumName: formData.condominiumName,
          phone: formData.phone,
          address: formData.address || ''
        })
      });

      const data = await resp.json();
      
      console.log('📵 Respuesta del servidor:', data);
      
      if (!resp.ok) {
        throw new Error(data.message || 'Error al registrar administrador');
      }

      // ❌ NO GUARDAR TOKEN NI USUARIO EN LOCALSTORAGE
      // ❌ localStorage.setItem('token', data.token);
      // ❌ localStorage.setItem('user', JSON.stringify(data.user));

      console.log('✅ Registro exitoso. CondominiumID:', data.condominiumId);
      console.log('🔑 Token temporal generado:', data.registrationToken);

      // ✅ Navegar a planes CON state pero SIN autenticar
      navigate('/planes', { 
        state: { 
          userId: data.userId,
          condominiumId: data.condominiumId,
          condominiumName: data.condominiumName,
          registrationToken: data.registrationToken, // Token temporal
          userEmail: formData.email,
          userName: formData.name,
          justRegistered: true
        },
        replace: true // Prevenir volver atrás
      });

    } catch (err) {
      console.error('❌ Error en registro:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="card-left">
            <button 
              className="back-button" 
              onClick={() => navigate('/login')}
              type="button"
            >
              ← 
            </button>
            
            <h2 className="login-title">Crear Cuenta Administrativa</h2>
            <p className="login-subtitle">Regístrese para gestionar su condominio</p>
            
            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleRegister}>
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nombre completo del administrador"
                  required
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Nombre de usuario"
                  required
                />
              </div>

              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email corporativo"
                  required
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="condominiumName"
                  value={formData.condominiumName}
                  onChange={handleChange}
                  placeholder="Nombre del condominio/conjunto residencial"
                  required
                />
              </div>

              <div className="input-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Teléfono de contacto (opcional)"
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Dirección del condominio (opcional)"
                />
              </div>

              <div className="input-group">
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Contraseña (mínimo 6 caracteres)"
                  required
                  minLength="6"
                />
              </div>

              <div className="input-group">
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirmar contraseña"
                  required
                  minLength="6"
                />
              </div>

              <button 
                type="submit" 
                className="login-button"
                disabled={loading}
              >
                {loading ? 'Procesando...' : 'Continuar a planes'}
              </button>
            </form>

            <div style={{ 
              marginTop: '1.5rem', 
              textAlign: 'center',
              fontSize: '0.9rem',
              color: '#666'
            }}>
              ¿Ya tienes cuenta?{' '}
              <span 
                onClick={() => navigate('/login')}
                style={{ 
                  color: '#4A90E2', 
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Iniciar sesión
              </span>
            </div>

            {/* ✅ ADVERTENCIA DE SEGURIDAD */}
            <div style={{
              marginTop: '2rem',
              padding: '1rem',
              background: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '8px',
              fontSize: '0.85rem',
              color: '#856404'
            }}>
              <strong>🔒 Nota importante:</strong> Tu cuenta será activada después de completar el proceso de pago. 
              Este enlace es válido por 24 horas.
            </div>
          </div>
          
          <div className="card-right" />
        </div>
      </div>
    </div>
  );
}
